import React from 'react';

import { LinkedLogo, NamedLink } from '../../components';
import { useConfiguration } from '../../context/configurationContext';

import css from './FooterContainer.module.css';

const FooterColumn = ({ title, children }) => (
  <nav className={css.column} aria-label={title}>
    <h2>{title}</h2>
    <div className={css.links}>{children}</div>
  </nav>
);

const FooterComponent = () => {
  const config = useConfiguration();
  const marketplaceName = config.marketplaceName || 'Hotline Glam';

  return (
    <div className={css.root}>
      <div className={css.inner}>
        <div className={css.brand}>
          <LinkedLogo
            id="logo-footer"
            className={css.logoLink}
            layout="desktop"
            alt={marketplaceName}
            linkToExternalSite={config?.topbar?.logoLink}
          />
          <p className={css.tagline}>Find Sydney makeup artists in one place.</p>
          <a
            className={css.instagram}
            href="https://www.instagram.com/hotlineglam.co/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Hotline Glam on Instagram"
          >
            <svg className={css.instagramIcon} viewBox="0 0 24 24" aria-hidden="true">
              <rect x="3" y="3" width="18" height="18" rx="5" />
              <circle cx="12" cy="12" r="4" />
              <circle cx="17.5" cy="6.5" r="1" />
            </svg>
            @hotlineglam.co
          </a>
        </div>

        <FooterColumn title="Explore">
          <NamedLink name="LandingPage" className={css.link}>
            Home
          </NamedLink>
          <NamedLink name="SearchPage" className={css.link}>
            Find an artist
          </NamedLink>
          <NamedLink name="HowItWorksPage" className={css.link}>
            How It Works
          </NamedLink>
          <NamedLink name="AboutPage" className={css.link}>
            About
          </NamedLink>
          <NamedLink name="CMSPage" params={{ pageId: 'faqs' }} className={css.link}>
            FAQs
          </NamedLink>
        </FooterColumn>

        <FooterColumn title="For Artists">
          <NamedLink
            name="SignupForUserTypePage"
            params={{ userType: 'provider' }}
            className={css.link}
          >
            Join as an artist
          </NamedLink>
          <NamedLink name="NewListingPage" className={css.link}>
            Post a listing
          </NamedLink>
          <NamedLink
            name="CMSPage"
            params={{ pageId: 'faqs' }}
            to={{ hash: 'for-artists-heading' }}
            className={css.link}
          >
            Artist FAQs
          </NamedLink>
        </FooterColumn>

        <FooterColumn title="Legal">
          <NamedLink name="TermsOfServicePage" className={css.link}>
            Terms of Service
          </NamedLink>
          <NamedLink name="PrivacyPolicyPage" className={css.link}>
            Privacy Policy
          </NamedLink>
        </FooterColumn>
      </div>

      <div className={css.bottom}>
        <span>© 2026 Hotline Glam. All rights reserved.</span>
        <span>Sydney, Australia</span>
      </div>
    </div>
  );
};

export default FooterComponent;
